import { useEffect, useState } from "react";
import { type UnknownAction } from "redux";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { WFPButton } from "@/components/ui/button";
import { Farm2GoIcon } from "@/components/Farm2GoIcon";
import { applicationVersion } from "../../actions";

export const UpdateApplicationBanner = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [newVersion, setNewVersion] = useState<string | null>(null);

  useEffect(() => {
    const fetchVersion = dispatch(
      applicationVersion() as unknown as UnknownAction
    ) as unknown as Promise<string>;
    fetchVersion.then(version => {
      if (!version) return;
      const stored = localStorage.getItem("version");
      if (!stored) {
        localStorage.setItem("version", version);
      } else if (stored !== version) {
        setNewVersion(version);
      }
    });
  }, [pathname, dispatch]);

  if (!newVersion) return null;

  const onReload = () => {
    localStorage.setItem("version", newVersion);
    window.location.reload();
  };

  return (
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={event => event.preventDefault()}
        onInteractOutside={event => event.preventDefault()}
        className="content-center justify-items-center gap-10 p-10 text-center sm:min-h-96 sm:max-w-3xl"
      >
        <div className="grid justify-items-center gap-8">
          <p className="m-0 flex items-center gap-3 text-3xl font-bold text-primary">
            <Farm2GoIcon className="size-20" />
            Farm2Go
          </p>
          <DialogHeader className="items-center gap-4 sm:text-center">
            <DialogTitle className="text-2xl font-bold leading-tight">
              {t("updateApplicationBanner.title")}
            </DialogTitle>
            <DialogDescription className="text-base">
              {t("updateApplicationBanner.info")}
            </DialogDescription>
          </DialogHeader>
        </div>
        <DialogFooter className="sm:justify-center">
          <WFPButton onClick={onReload}>
            <RefreshCw aria-hidden="true" />
            {t("updateApplicationBanner.reload")}
          </WFPButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
